export default __webpack_public_path__ + "static/media/pdfDarkLogo.5c6bd3da.svg";